import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createConsultation, deleteConsultationAsync, fetchConsultations, updateConsultationAsync } from "../../../ReduxSlices/Admin/consultationServiceSlice";
import LoadingDots from "../../shared/LoadingDots";


const ConsultationManagement = () => {
  const dispatch = useDispatch();
  const { consultations, submitting, error, loading } = useSelector((state) => state.consultations)
  const [formData, setFormData] = useState({ name: "", fee: "" });
  const [editingConsultation, setEditingConsultation] = useState(null);
  const [activeTab, setActiveTab] = useState("list");

  useEffect(() => {
   if(consultations.length === 0){
    dispatch(fetchConsultations());
   }
  }, [dispatch, consultations.length]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    // Strip out `id` if present in formData
    const { id, ...cleanFormData } = {...formData, fee: parseFloat(formData.fee)};

      if (isNaN(cleanFormData.fee)) {
        alert("Please enter a valid number for fee");
        return;
      }

      if (editingConsultation) {
          await dispatch(updateConsultationAsync({ id: editingConsultation.id, data: cleanFormData }));
        } else {
          await dispatch(createConsultation(cleanFormData));
        }


      if (!error) {
        setFormData({ name: "", fee: "" });
        setEditingConsultation(null);
        setActiveTab("list");
      } else {
        alert(error);
      }
  };

  const handleEdit = (consultation) => {
    setEditingConsultation(consultation);
    setFormData(consultation);
    setActiveTab("form");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this consultation service?")) {
      dispatch(deleteConsultationAsync(id));
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">Consultation services</h2>

      {/* Tabs */}
      <div className="flex gap-[5px] mb-4">
           <button
          className={`px-4 py-2 rounded ${activeTab === "list" ? "primary extra" : "secondary"}`}
          onClick={() => setActiveTab("list")}
        >
          Consultation Services
        </button>

        <button
          className={`px-4 py-2 rounded ${activeTab === "form" ? "primary extra" : "secondary"}`}
          onClick={() => setActiveTab("form")}
        >
          {editingConsultation ? "Update consultation service" : "Add a consultation service"}
        </button>
     
      </div>

      {/* Tab Content */}
      {activeTab === "form" && (
        <form onSubmit={handleSubmit} className="user-form space-y-4 p-[20px]">
          <input
            type="text"
            name="name"
            placeholder="Consultation Name"
            value={formData.name}
            onChange={handleChange}
            className="border p-2 w-full rounded"
            required
          />
          <input
            type="number"
            name="fee"
            placeholder="Consultation Fee"
            value={formData.fee}
            onChange={handleChange}
            step="0.01"
            className="border p-2 w-full rounded"
            required
          />
          <div className="flex justify-between w-[45%]">
            <button className="primary wide" disabled={submitting}>
               {submitting
                ? editingConsultation
                  ? "Updating..."
                  : "Saving..."
                : editingConsultation
                ? "Update Consultation"
                : "Add Consultation"}
            </button>
             {editingConsultation && (
                  <button
                    type="button"
                    className="secondary"
                    onClick={() => {
                      setEditingConsultation(null);
                      setFormData({ name: "", fee: "" });
                      setActiveTab("list");
                    }}
                  >
                    Cancel
                  </button>
                )}
          </div>
        </form>
      )}

      {activeTab === "list" && (
        <div className="mt-[2rem]" >
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-2 text-left">Name</th>
                <th className="border p-2 text-right">Fee</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center p-4">
                    <LoadingDots height={10} width={30} color="#38AD3E" />
                  </td>
                </tr>
              ) :
              consultations.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center p-4">No consultations found.</td>
                </tr>
              ) : (consultations.map((consultation) => (
                <tr key={consultation.id} className="lighten">
                  <td className="border p-2 text-left">{consultation.name}</td>
                  <td className="border p-2 text-right">
                    KSh {new Intl.NumberFormat('en-KE', { minimumFractionDigits: 2 }).format(consultation.fee)}
                    </td>
                  <td className="border p-2 text-center ">
                    <div className="action-btns">

                    <button
                      onClick={() => handleEdit(consultation)}
                      className="primary"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(consultation.id)}
                      className="secondary error-msg"
                    >
                      Delete
                    </button>

                    </div>
                  </td>
                </tr>
              )))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ConsultationManagement;
